import { getCurrentInstance } from 'vue'

export const useGlobalProperties = () => {
  const { emit, appContext: {app: {config: {globalProperties}}}} = getCurrentInstance()

  return {...globalProperties}
}